import React from 'react';
import { Box, Typography } from '@mui/material';

interface WorkflowHeaderProps {
  title?: string;
  subtitle?: string;
}

export const WorkflowHeader: React.FC<WorkflowHeaderProps> = ({
  title = 'Batch Workflow',
  subtitle = 'Manage batch processing and delivery workflows',
}) => {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
